import { Card, CardContent, CardHeader, CardTitle } from "../ui/card"
import { CheckCircle2, Clock, FileText, PhoneCall, Euro, Briefcase, UserPlus, GraduationCap } from "lucide-react"

const defaultActivities = [
  {
    title: "Consulenza iniziale",
    description: "Appuntamento con Mario Rossi confermato",
    time: "10 min fa",
    icon: Clock,
    color: "text-blue-500",
    bg: "bg-blue-100",
  },
  {
    title: "Documentazione caricata",
    description: "Contratto firmato - Pratica #4521",
    time: "1 ora fa",
    icon: FileText,
    color: "text-purple-500",
    bg: "bg-purple-100",
  },
  {
    title: "Chiamata in uscita",
    description: "Contatto con Banca Intesa per Pratica #4500",
    time: "2 ore fa",
    icon: PhoneCall,
    color: "text-amber-500",
    bg: "bg-amber-100",
  },
  {
    title: "Pratica completata",
    description: "Chiusura accordo saldo e stralcio - Cliente Verdi",
    time: "5 ore fa",
    icon: CheckCircle2,
    color: "text-emerald-500",
    bg: "bg-emerald-100",
  },
]

const marketingActivities = [
  {
    title: "Campagna attivata",
    description: "Email Drip - Segmento Prospect Nord",
    time: "15 min fa",
    icon: Briefcase,
    color: "text-amber-600",
    bg: "bg-amber-100",
  },
  {
    title: "Nuovo asset pubblicato",
    description: "Creatività Social Ads Q1",
    time: "45 min fa",
    icon: FileText,
    color: "text-indigo-600",
    bg: "bg-indigo-100",
  },
  {
    title: "Ottimizzazione bid",
    description: "Brand Search - riduzione CPC del 8%",
    time: "1 ora fa",
    icon: CheckCircle2,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
]

const commercialActivities = [
  {
    title: "Nuovo lead assegnato",
    description: "Lead #4521 assegnato a Team Commerciale",
    time: "5 min fa",
    icon: Briefcase,
    color: "text-sky-500",
    bg: "bg-sky-100",
  },
  {
    title: "Follow-up programmato",
    description: "Richiamare Cliente Beta per proposta economica",
    time: "30 min fa",
    icon: PhoneCall,
    color: "text-amber-500",
    bg: "bg-amber-100",
  },
  {
    title: "Proposta inviata",
    description: "Offerta inviata per Pratica #4501",
    time: "1 ora fa",
    icon: FileText,
    color: "text-indigo-500",
    bg: "bg-indigo-100",
  },
]

const legalActivities = [
  {
    title: "Udienza iniziata",
    description: "Pratica #3201 - Tribunale Napoli",
    time: "15 min fa",
    icon: Clock,
    color: "text-red-500",
    bg: "bg-red-100",
  },
  {
    title: "Memoria depositata",
    description: "Pratica #3198 - Tribunale Milano",
    time: "1 ora fa",
    icon: FileText,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
  {
    title: "Nuova scadenza inserita",
    description: "Termine per deposito documenti tra 7 giorni",
    time: "2 ore fa",
    icon: CheckCircle2,
    color: "text-sky-600",
    bg: "bg-sky-100",
  },
]

const adminActivities = [
  {
    title: "Incasso registrato",
    description: "Fattura #2024-118 - Studio Rossi",
    time: "20 min fa",
    icon: Euro,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
  {
    title: "Insoluto segnalato",
    description: "Fattura #2024-115 - Cliente Beta",
    time: "1 ora fa",
    icon: FileText,
    color: "text-red-500",
    bg: "bg-red-100",
  },
  {
    title: "Riconciliazione avviata",
    description: "Allineamento movimenti bancari mensili",
    time: "3 ore fa",
    icon: CheckCircle2,
    color: "text-indigo-500",
    bg: "bg-indigo-100",
  },
]

const coordinationActivities = [
  {
    title: "Riunione coordinamento",
    description: "Allineamento settimanale con Commerciale e Legale",
    time: "30 min fa",
    icon: Briefcase,
    color: "text-sky-600",
    bg: "bg-sky-100",
  },
  {
    title: "Riassegnazione pratiche",
    description: "Ridistibuzione carico tra dipartimenti",
    time: "1 ora fa",
    icon: FileText,
    color: "text-amber-600",
    bg: "bg-amber-100",
  },
  {
    title: "Aggiornamento SLA",
    description: "Nuovi tempi obiettivo per gestione lead",
    time: "4 ore fa",
    icon: CheckCircle2,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
]

const hrActivities = [
  {
    title: "Nuovo onboarding iniziato",
    description: "Benvenuto a Laura Bianchi - Team Amministrazione",
    time: "30 min fa",
    icon: UserPlus,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
  {
    title: "Colloqui pianificati",
    description: "3 colloqui di selezione per posizione Sales",
    time: "2 ore fa",
    icon: Clock,
    color: "text-sky-600",
    bg: "bg-sky-100",
  },
  {
    title: "Sessione di Formazione",
    description: "Workshop su comunicazione efficace per i Team Leader",
    time: "Domani, 15:00",
    icon: GraduationCap,
    color: "text-indigo-600",
    bg: "bg-indigo-100",
  },
]

const leadActivities = [
  {
    title: "Nuovo lead ricevuto",
    description: "Fonte Web - modulo contatti",
    time: "10 min fa",
    icon: UserPlus,
    color: "text-orange-600",
    bg: "bg-orange-100",
  },
  {
    title: "Qualifica in corso",
    description: "Verifica requisiti per Lead #L-785",
    time: "35 min fa",
    icon: Briefcase,
    color: "text-indigo-600",
    bg: "bg-indigo-100",
  },
  {
    title: "Contatto effettuato",
    description: "Chiamata al referente - esito positivo",
    time: "1 ora fa",
    icon: PhoneCall,
    color: "text-sky-600",
    bg: "bg-sky-100",
  },
  {
    title: "Assegnazione team",
    description: "Lead assegnato a Team Commerciale A",
    time: "2 ore fa",
    icon: CheckCircle2,
    color: "text-emerald-600",
    bg: "bg-emerald-100",
  },
]

export function ActivityTimeline({ variant = "default" }) {
  const normalizedVariant = variant.toLowerCase()

  let title = "Attività Recenti"
  let activities = defaultActivities

  if (normalizedVariant === "commerciale") {
    title = "Attività Commerciali"
    activities = commercialActivities
  } else if (normalizedVariant === "lead") {
    title = "Attività Lead"
    activities = leadActivities
  } else if (normalizedVariant === "marketing") {
    title = "Attività Marketing"
    activities = marketingActivities
  } else if (normalizedVariant === "legale") {
    title = "Attività Studio Legale"
    activities = legalActivities
  } else if (normalizedVariant === "amministrazione") {
    title = "Movimenti Amministrativi"
    activities = adminActivities
  } else if (normalizedVariant === "coordinamento") {
    title = "Attività di Coordinamento"
    activities = coordinationActivities
  } else if (normalizedVariant === "risorse umane" || normalizedVariant === "hr") {
    title = "Attività Risorse Umane"
    activities = hrActivities
  }

  return (
    <Card className="border-none shadow-sm h-full">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-8 relative before:absolute before:inset-0 before:ml-5 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-border before:to-transparent before:translate-x-0.5">
          {activities.map((activity, index) => (
            <div key={index} className="relative flex items-start gap-4">
              <div
                className={`relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${activity.bg} shadow-sm ring-4 ring-white`}
              >
                <activity.icon className={`h-5 w-5 ${activity.color}`} />
              </div>
              <div className="flex flex-col space-y-1 pt-1">
                <p className="text-sm font-medium leading-none">{activity.title}</p>
                <p className="text-xs text-muted-foreground">{activity.description}</p>
                <p className="text-[10px] text-muted-foreground pt-1 font-medium">{activity.time}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
